<template>
  <a-card :bordered="false">
    <div style="margin-bottom:20px">库存为0或不添加，则预约页面不显示对应内容</div>
    <a-form-model ref="subjoinForm" :model="subjoinForm" :rules="subjoinRules">
      <a-form-model-item v-if="subjoinForm.detailList&&subjoinForm.detailList.length>0" style="margin-bottom:0"
                         v-for="(detailList, index) in subjoinForm.detailList "
                         :key="index"
      >
        <a-form-model-item style="display:inline-block"
                           :prop="'detailList.' + index + '.goodsName'"
                           :rules="{ required: true, message: '请输入附加商品名称', trigger: 'blur'}"
        >
          <a-input placeholder="附加商品名称" style="width:200px;" :maxLength="20" v-model="detailList.goodsName"/>
          <span class='padding-num'>库存</span>
        </a-form-model-item>
        <a-form-model-item style="display:inline-block"
                           :prop="'detailList.' + index + '.stock'"
                           :rules="[
          { required: true, message: '请输入', trigger: 'blur'},
          { pattern: /^[0-9]\d{0,5}$/,message: '请输入正确的库存',trigger:'blur'}
        ]"
        >
          <a-input placeholder="请输入" v-model="detailList.stock" style="max-width: 100px;"/>
          <span class='padding-num'>，单价</span>
        </a-form-model-item>
        <a-form-model-item style="display:inline-block"
                           :prop="'detailList.' + index + '.settlePrice'"
                           :rules="[
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/,message: '请输入正确的金额',trigger: 'blur'},
        ]"
        >
          <a-input placeholder="请输入" v-model="detailList.settlePrice" style="max-width: 100px;"/>
          <span class='padding-num'>元</span>
        </a-form-model-item>
        <a-form-model-item
          v-if="couponType=='JHM'" style="display:inline-block"
          :prop="'detailList.' + index + '.selectedActive'"
          :rules="{ required: true, message: '请选择', trigger: 'change' }"
        >
          <a-cascader
            style="max-width: 200px;"
            :options="arrOptions"
            v-model="detailList.selectedActive"
            placeholder="请选择"
          />
        </a-form-model-item>
        <a-icon v-if="subjoinForm.detailList.length > 0" class="dynamic-delete-button" type="minus-circle-o"
                @click="removeDetailList(detailList)"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="dashed" @click="addDetailList">
          <a-icon type="plus"/>
          添加
        </a-button>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="onSubmit" :loading="submitLoading">保存设置</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
export default {
  name: 'SubjoinComponents',
  props: {
    activateKey: {
      type: String,
      default: 'tab3'
    }
  },
  data() {
    return {
      subjoinForm: {
        optionProId: this.$route.query.proId,
        detailList: []
      },
      couponType: this.$route.query.couponType,
      submitLoading: false,
      subjoinRules: {},
      arrOptions: []
    }
  },
  created() {
    this.getBuyTypeSelect()
  },
  mounted() {
    this.getAttachedDetail()
  },
  methods: {
    getAttachedDetail() {
      this.getHttpServices().getProService().get('bespeak/attachedDetail?optionProId=' + this.$route.query.proId)
        .then(res => {
          if (res && res.length > 0) {
            this.getLogUtils().logWithTag('res', res)
            let detailList = res.map(item => {
              return {
                ...item,
                selectedActive: item.buyType && item.buySelect ? [item.buyType, item.buySelect] : []
              }
            })
            this.subjoinForm.detailList = detailList
            this.$nextTick(() => {
              this.subjoinForm = { ...this.subjoinForm }
            })
            this.getLogUtils().logWithTag('this.subjoinForm+++', this.subjoinForm)
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getBuyTypeSelect() {
      this.getHttpServices().getProService().get('bespeak/getAttachedBuyTypeSelect').then(res => {
        this.getLogUtils().logWithTag('getBuyTypeSelect', res)
        if (res && res.length > 0) {
          this.arrOptions = res
        } else {
          this.arrOptions = []
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSubmit() {
      this.$refs.subjoinForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      if (this.subjoinForm.detailList.length > 0) {
        let params = JSON.parse(JSON.stringify(this.subjoinForm))
        let detailList = params.detailList.map(item => {
          return {
            ...item,
            buyType: item.selectedActive && item.selectedActive.length > 0 ? item.selectedActive[0] : undefined,
            buySelect: item.selectedActive && item.selectedActive.length > 1 ? item.selectedActive[1] : undefined
          }
        })
        params.detailList = detailList
        params.detailList.forEach(item => {
          delete item.price
          delete item.selectedActive
        })
        this.getLogUtils().logWithTag('params', params)
        this.submitLoading = true
        this.getHttpServices().getProService().post('bespeak/attached', params).then(info => {
          this.$message.success('提交成功')
          this.getAttachedDetail()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      } else {
        this.$message.error('请添加内容')
      }
    },
    removeDetailList(item) {
      let index = this.subjoinForm.detailList.indexOf(item)
      if (index !== -1) {
        this.subjoinForm.detailList.splice(index, 1)
      }
    },
    addDetailList() {
      if (this.subjoinForm.detailList.length >= 5) {
        this.$message.error('最多可以添加5个附加商品')
      } else {
        this.subjoinForm.detailList.push({
          goodsName: '',
          settlePrice: '',
          stock: '',
          selectedActive: null
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.dynamic-delete-button {
  font-size: 22px;
  margin-left: 10px;
}

.padding-num {
  padding: 0 10px;
}
</style>
